import React, { useState, useEffect, useRef } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { ResourceRequester } from "sulu-admin-bundle/services";
import { CircularProgress } from "@mui/material";
import { init } from "i18next";

export default function PitchSelect({
    match,
    pitchOptions,
    setPitchOptions,
    onChangeForm,
    form,
}) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState(match?.pitch || "");
    const [value, setValue] = useState(
        match?.pitch && match?.pitchID
            ? { id: match.pitchID, name: match.pitch }
            : null
    );

    const initOpen = useRef(false);

    useEffect(() => {
        if (!value && form.pitchName) {
            setValue({ id: form.pitch || form.pitchID, name: form.pitchName });
        }
    }, [form.pitch]);

    useEffect(() => {
        if (!form.pitchID && !form.pitch) {
            setValue(null);
            setInputValue("");
            initOpen.current = false;
        }
    }, [pitchOptions]);

    const handleInputChange = (_, newInputValue) => {
        setInputValue(newInputValue);
    };

    const handleChange = (_, newValue) => {
        if (newValue === null) {
            setValue(null);
            setInputValue("");
            onChangeForm({ pitchID: null, pitch: null });
            return;
        }

        setValue(newValue);
        setInputValue(newValue.name);
        onChangeForm({ pitchID: newValue.id, pitch: newValue.name });
    };

    const handleOpen = async () => {
        if (initOpen.current || !form.location) return;

        initOpen.current = true;

        setLoading(true);
        try {
            const response = await ResourceRequester.getList("dhbpitches", {
                location: form?.locationID || form?.location?.id,
            });

            setPitchOptions(response?._embedded?.dhbpitches || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Autocomplete
            onOpen={handleOpen}
            value={value}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onChange={handleChange}
            options={pitchOptions}
            loading={loading}
            getOptionLabel={(option) =>
                typeof option === "string" ? option : option?.name || ""
            }
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            renderOption={(props, option) => (
                <li {...props} key={option.id}>
                    {option.name}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t("gamedays.match.pitches_label") || "Pitch"}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                )}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}
